import axios from 'axios';
import {
  ADD_TO_CART,
  CLEAN_CART,
  EDIT_CART_QUANTITY,
  GET_CART_FROM_STORAGE,
  REMOVE_FROM_CART,
  REMOVE_COD_ARTICU_FROM_CART,
  ATTACH_SHIPMENT_INFO,
  PROCESS_CART_PURCHASE, USER_AUTH_SUCCESS
} from "@/store/mutation-types";
import Api from "@/Api";

// Helper function to get the effective price of a product (with discount applied)
const getProductPrice = (product) => {
  if (product.enable_discount && product.discount_percentage > 0) {
    return product.price * (1 - product.discount_percentage / 100);
  }
  return product.price;
};

const state = {
  total: 0,
    subtotal: 0,
    discount_value: 0,
  items:[],
  shipment:{
    forma_envio:'',
    envio_observacion:'',
  },
  paymentType:'TR',
  user: JSON.parse(localStorage.getItem('gorsh_user')) || {}
};

const getters = {
  cart_total: state => state.total,
  cart_subtotal: state => state.subtotal,
  cart_items: state => state.items,
  shipment: state => state.shipment,
  payment: state => state.paymentType,
  discount_value: state => state.discount_value
};

const actions = {


  loadCartFromStorage(store, { product }) {
    return new Promise((resolve, reject) => {
      Api().get('template/list')
      .then(({ data }) => {
            if (data){
              store.commit(GET_CART_FROM_STORAGE, {data: (data.data)?data.data:[] });
              resolve(true);
            }
      }).catch((e) => {
        console.error(e);
        reject(false);
      });

    });
  },

  editCartQuantity(store,{product,quantity}){


    return new Promise((resolve, reject) => {
      let item = store.commit(EDIT_CART_QUANTITY, { product, quantity});
      resolve(true);
    });
  },

  addToCart (store, { product,quantity }) {


    return new Promise((resolve, reject) => {

      if (!quantity)quantity=1;

      var record = state.items.find(p => p.product.code === product.code);


      if (record) {
        var newQuantity = parseInt(parseInt(record.quantity) + parseInt(quantity));

        if (record.product.stock_available < newQuantity)
          reject(new Error("La cantidad supera el stock Máximo: " + record.product.stock_available));
      }


      let item = store.commit(ADD_TO_CART, { product: product, quantity: quantity});


      resolve(state.items[state.items.length-1]);
    });

  },

  cleanCart(store){
    return new Promise((resolve, reject) => {
      store.commit(CLEAN_CART, { });
      resolve(true);
    });
  },

  removeFromCart(store,{item}){
      return new Promise((resolve, reject) => {
        store.commit(REMOVE_FROM_CART, { product: item});
        resolve(true);
      });

  },

  RemoveCodArticuFromCart(store, codArticu) {
    return new Promise((resolve, reject) => {
      store.commit(REMOVE_COD_ARTICU_FROM_CART, { codArticu });
      resolve(true);
    });
  },

  attachShipment(store,{shipment}){
    return new Promise((resolve, reject) => {
      store.commit(ATTACH_SHIPMENT_INFO, { shipment: shipment});
      resolve(true);
    });
  },
  processCartPurchase(store,{order}){
    return new Promise((resolve, reject) => {

      Api().post('order/place', order)
        .then(({ data }) => {
          console.log(data);
          if (data.status===1) {
            store.commit(PROCESS_CART_PURCHASE, {});
            resolve();
          } else {
            reject(data.error);
          }
        }).catch((error) => {
          console.log(error);
          if (error.response) {
            const errorJson = error.response.data.error;
            reject(errorJson);
          } else {
            reject('No pudimos conectarnos con el servidor!');
          }

        });
    });

  }


};

const mutations = {
  [CLEAN_CART] (store, { }) {
    store.items = [];
    store.total = 0;
      store.subtotal = 0;
      store.discount_value = 0;
    localStorage.removeItem('cart');
  },
  [GET_CART_FROM_STORAGE] (store, { data }) {

    if (!Array.isArray(data))
    {
      data = Object.values(data);
    }

    state.items = data;

    state.items.map(item=>{

      var effectivePrice = getProductPrice(item.product);
      var subtotalItem = parseFloat(effectivePrice) * item.quantity;
      var subtotal = parseFloat(state.subtotal) + subtotalItem;


        // APLICA DESCUENTOS SI EXISTEN
      if (state.user.discounts){
        state.user.discounts.forEach((el) => {
          if( el.t === 'percent'){
            if( subtotal > el.gt && subtotal <= el.lt ){
              state.discount_value = ((el.d * subtotal) / 100);
              //console.log("Descuento aplicado > "+el.d+"%");
              //console.log("Descuento aplicado > $ "+state.discount_value);
            }
          }
        });
      }

      state.subtotal = subtotal;
      state.total = subtotal - state.discount_value;
    });

  },
  [EDIT_CART_QUANTITY] (store, { product , quantity}) {
    //TODO esto no esta andando revisar
    var index = state.items.indexOf(product);

    state.items[index] = product;

    state.total = 0;
    state.subtotal = 0;
    state.discount_value = 0;

    state.items.map(item=>{

        //var total = parseFloat(item.product.precio_mayorista) * item.quantity;
        //state.total = parseFloat(state.total) + total;

        var effectivePrice = getProductPrice(item.product);
        var subtotalItem = parseFloat(effectivePrice) * item.quantity;
        var subtotal = parseFloat(state.subtotal) + subtotalItem;

        // APLICA DESCUENTOS SI EXISTEN
        /*state.user.discounts.forEach((el) => {
            if( el.t === 'percent'){
                if( subtotal > el.gt && subtotal <= el.lt ){
                    state.discount_value = ((el.d * subtotal) / 100);
                    console.log("Descuento aplicado > "+el.d+"%");
                    console.log("Descuento aplicado > $ "+state.discount_value);
                }
            }
        });*/


        state.subtotal = subtotal;
        state.total = subtotal - state.discount_value;
    });

    localStorage.setItem('cart', JSON.stringify(state.items));

  },
  [REMOVE_FROM_CART] (store, { product }) {
    console.log(product);
        var effectivePrice = getProductPrice(product.product);
        var subtotalItemRemoved = parseFloat(effectivePrice) * product.quantity;
        var subtotal = parseFloat(state.subtotal) - subtotalItemRemoved;
        state.discount_value = 0;

      // APLICA DESCUENTOS SI EXISTEN

      if (state.user.discounts)
      {
        state.user.discounts.forEach((el) => {
          if( el.t === 'percent'){
            if( subtotal > el.gt && subtotal <= el.lt ){
              state.discount_value = ((el.d * subtotal) / 100);
              //console.log("Descuento aplicado > "+el.d+"%");
              //console.log("Descuento aplicado > $ "+state.discount_value);
            }
          }
        });
      }



      state.subtotal = subtotal;
      state.total = subtotal - state.discount_value;

    //state.total = state.total - total;
    state.items.splice(state.items.indexOf(product), 1);


    const cartItemJson = state.items.map((item)=>{
    return {
      quantity:item.quantity,
        code:item.product.code
    }});

    Api().post('template/add', {cart:cartItemJson})
      .then(({ data }) => {
      }).catch(() => {
      });



  },
  [REMOVE_COD_ARTICU_FROM_CART] (store, { codArticu }) {
    const productIndex = state.items.findIndex(item => item.product.code === codArticu);

    if (productIndex !== -1) {
      const product = state.items[productIndex];
      var effectivePrice = getProductPrice(product.product);
      var subtotalItemRemoved = parseFloat(effectivePrice) * product.quantity;
      var subtotal = parseFloat(state.subtotal) - subtotalItemRemoved;
      state.discount_value = 0;

      // APLICA DESCUENTOS SI EXISTEN
      if (state.user.discounts) {
        state.user.discounts.forEach((el) => {
          if( el.t === 'percent'){
            if( subtotal > el.gt && subtotal <= el.lt ){
              state.discount_value = ((el.d * subtotal) / 100);
            }
          }
        });
      }

      state.subtotal = subtotal;
      state.total = subtotal - state.discount_value;
      state.items.splice(productIndex, 1);

      const cartItemJson = state.items.map((item)=>{
        return {
          quantity:item.quantity,
          code:item.product.code
        }});


      Api().post('template/add', {cart:cartItemJson})
        .then(({ data }) => {
        }).catch(() => {
        });
    }
  },
  [ATTACH_SHIPMENT_INFO](store,{shipment}){
    state.shipment.envio_observacion = shipment.envio_observacion;
    state.shipment.forma_envio = shipment.forma_envio;
  },
  [ADD_TO_CART] (store, { product, quantity}) {
    var record = state.items.find(p => p.product.code === product.code);


    if (!record) {
      state.items.push({product, quantity: quantity});
    } else {

      var newQuantity = parseInt(parseInt(record.quantity) + parseInt(quantity));

      if (record.product.STOCK<newQuantity)
        return false;

      record.quantity = parseInt(parseInt(record.quantity) + parseInt(quantity));
    }

    state.total = 0;
    state.subtotal = 0;
    state.discount_value = 0;


    state.items.map(item=>{

        var effectivePrice = getProductPrice(item.product);
        var subtotalItem = parseFloat(effectivePrice) * item.quantity;
        var subtotal = parseFloat(state.subtotal) + subtotalItem;

        // APLICA DESCUENTOS SI EXISTEN
        if(state.user.discounts instanceof Array) {
          state.user.discounts.forEach((el) => {
            if (el.t === 'percent') {
              if (subtotal > el.gt && subtotal <= el.lt) {
                state.discount_value = ((el.d * subtotal) / 100);
                console.log("Descuento aplicado > " + el.d + "%");
                console.log("Descuento aplicado > $ " + state.discount_value);
              }
            }
          });
        }

        // TODO: Get Discounts data from User:
        /* if( subtotal > 9999 && subtotal <= 19999 ){
            console.log("Descuento aplicado > 5%");
            state.discount_value = ((5 * subtotal) / 100);
        }
        if( subtotal > 19999 && subtotal <= 999999999 ){
            console.log("Descuento aplicado > 5%");
            state.discount_value = ((10 * subtotal) / 100);
        } */


        state.subtotal = subtotal;
        state.total = subtotal - state.discount_value;

    });

    const cartItemMapped = state.items.map((item)=>{
      return {
        quantity:item.quantity,
        code:item.product.code
      }});

    const cartItemJson = JSON.stringify(cartItemMapped);


      Api().post('template/add', {cart:cartItemMapped})
        .then(({ data }) => {
        }).catch(() => {
        });


    return true;
  },
  [PROCESS_CART_PURCHASE](store,{}){
    state.total = 0;
    state.subtotal = 0;
      state.discount_value = 0;
    state.items = [];

    state.shipment = {
      forma_envio:'',
        envio_observacion:'',
    };

    state.paymentType = 'TR';
    localStorage.removeItem('cart');
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/cart.js